<nz-switch
  [formlyAttributes]="field"
  nzSize="small"
  [formControl]="formControl"
></nz-switch>
<span class="switch-label">{{ field.templateOptions?.label }}</span>
